<script>
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Common from '../../../common/Common.vue'
import Services from '../../../common/Services.vue'
import { applySessionScope } from '../../../utils/scope'
export default {
    init: async payload => {
        const role = await Common.getSubtype(payload)
        payload.role = role

        payload.initTable()

        payload.isSuperAdminMaster = await Common.isSuperAdminMaster(payload)

        if (!payload.isSuperAdminMaster) {
            payload.columns.splice(2, 1)
        }

        if (role === 'AUDITOR') {
            payload.columns.splice(2, 1)
        }

        payload.accounts = await Services.getAccounts(payload)
        const account = await Common.getAccountId(payload)

        payload.filters.account = account
        if (account) {
            payload.clients = await Services.getClients(payload)
        }

        if (role === 'MANAGER' || role === 'OPERATOR' || role === 'AUDITOR') {
            const client = await Common.getClientId(payload)
            payload.filters.client = client
            payload.sites = await Services.getSites(payload)
        }
    },
    methods: {
        filter: function () {
            if (!applySessionScope(this, this.filters)) return

            this.isLoading = true
            this.items = []
            this.enrichFiltersWithPagination()
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.filters,
                `${Endpoints.incidents.filter}`,
                response => {
                    this.applyServerPage(response)
                    this.isLoading = false
                },
                () => {
                    this.isLoading = false
                },
            )
        },
        selectItem(params) {
            if (this.role === 'AUDITOR') return

            const data = params && params?.row ? JSON.parse(JSON.stringify(params.row)) : { ...this.incidentObj }

            delete data.vgt_id
            delete data.originalIndex

            data.account = data?.account?._id || ''
            data.client = data?.client?._id || ''
            data.site = data?.site?._id || ''

            this.data = data

            this.$bvModal.show('createIncidentModal')
        },
        async initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.incident.column.name'),
                    field: 'name',
                    width: '30%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.incident.column.priority'),
                    field: 'priority',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.incident.column.account'),
                    field: 'account',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                    sortFn: Common.sortAccountFn,
                },
                {
                    label: this.$t('str.table.incident.column.client'),
                    field: 'client',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                    sortFn: Common.sortClientFn,
                },
                {
                    label: this.$t('str.table.incident.column.site'),
                    field: 'site',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                    sortFn: Common.sortSiteFn,
                },
                {
                    label: this.$t('str.table.incident.column.creat.at'),
                    field: 'createDate',
                    width: '15%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.incident.column.status'),
                    field: 'status',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: false,
                    filterable: false,
                },
            ]
            this.paginationOptions = this.buildServerPaginationOptions(this)
        },
        changeAccount: async function () {
            const account = this.filters.account

            this.sites = []
            this.filters.client = ''
            this.filters.site = ''

            this.filterFromFirstPage()

            this.clients = await Services.getClientsByAccount(this, account)
        },
        changeClient: async function () {
            const client = this.filters.client

            if (client === '') {
                this.filters.site = ''
            }

            this.filterFromFirstPage()

            this.sites = await Services.getSitesByClient(this, client)
        },
        changeSite: function () {
            this.filterFromFirstPage()
        },
        formatDate: Common.formatDateAndTime,
    },
}
</script>
